<template>
  <svg-icon :name="name" class="sword-icon" />
</template>

<script>
import SvgIcon from 'vue-svgicon';
import '@ui-kit/icons';

export default {
  name: 'SwordIconWuk',
  components: { SvgIcon },
  props: {
    name: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
  .sword-icon {
    /* recommended css code for vue-svgicon */
    &.svg-icon {
      display: inline-block;
      width: 20px;
      height: 20px;
      color: inherit;
      vertical-align: middle;
      fill: none;
      stroke: currentColor;
    }

    &.svg-fill {
      fill: currentColor;
      stroke: none;
    }

    &.svg-up {
      /* default */
      transform: rotate(0deg);
    }

    &.svg-right {
      transform: rotate(90deg);
    }

    &.svg-down {
      transform: rotate(180deg);
    }

    &.svg-left {
      transform: rotate(-90deg);
    }
  }

</style>
